<template>
  <v-app class="grey lighten-5">
    <v-container>
      <v-row class="justify-start">
        <v-col class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="d-inline-flex primary--text">
            <v-icon class="mr-2" color="primary" size="35">payment</v-icon>
            <h1 class="text-md-left font-weight-bold primary--text">{{$t('patientPayment.title')}}</h1>
          </div>
        </v-col>
      </v-row>
      <hr class="primary--lightGray mt-3" />
      <v-col class="col-12">
        <v-row>
          <p class="primary--lightGray schedule-text mt-3">
            {{$t('patientPayment.subtitle')}}
          </p>
        </v-row>
      </v-col>
      <v-row class="justify-center">
        <v-col class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="d-flex align-center mt-6">
            <CardListPayment
              @addCard="addCard"
              cardType="Cartão de Crédito"
              type="cartao"
              :itens="patientCards"
              :editCreditCard="addCard"
              method="payment"
              @remove="deletePatientCard($event.id)"
            />
          </div>
          <div class="d-flex align-center mt-6" v-if="lang === 'pt'">
            <CardListPayment
              cardType="Débito Direto (SEPA)"
              @addCard="addSepa"
              type="Sepa"
              :itens="patientSepa"
              :editCreditCard="addSepa"
              method="payment"
              @remove="deletePatientMethodSepa($event.id)"
            />
          </div>
        </v-col>
        <v-col class="col-12 col-lg-6 col-xl-5">
          <FormCard :saveCardMethod="saveCardMethod" ref="newFormCard" />
          <FormSepa :saveSepadMethod="saveSepadMethod" ref="newFormSepa" />
        </v-col>
      </v-row>
      <div class="text-center" v-if="isLoading">
        <v-progress-circular
          :width="3"
          size="70"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import { mask } from 'vue-the-mask';
import { mapGetters } from 'vuex';
import CardListPayment from '@/components/PaymentMethods/CardListPayment.vue';
import FormCard from '@/components/PaymentMethods/FormCard.vue';
import FormSepa from '@/components/PaymentMethods/FormSepa.vue';

import * as types from '../../store/modules/cards/types';

import sepa from '../../../Sepa.json';

import {
  createCreditCard,
  getCreditCards,
  deleteCreditCard,
  updateCreditCard,
} from '../../services/patients';

import {
  creatMethodSepa,
  getMethodSepa,
  updateMethodSepa,
  deleteMethodSepa,
} from '../../services/paymentMethodSepa';
import getLanguage from '../../utils/getLanguage';

export default {
  components: {
    CardListPayment,
    FormCard,
    FormSepa,
  },
  name: 'PaymentMethods',
  data() {
    return {
      sepa,
      dialog: false,
      idCard: null,
      formMode: '',
      isFormValid: false,
      patientCards: [],
      patientSepa: [],
      isLoading: false,
      lang: '',
    };
  },
  computed: {
    ...mapGetters('cards', {
      isFirstCard: types.GET_FIRST_CARD,
    }),
  },
  created() {
    this.getPatientCards();
    this.getPatientMethodoSepa();
    this.lang = getLanguage(window.location.href);
  },
  methods: {
    addSepa(formSepaMethod = {}) {
      const { newFormSepa, newFormCard } = this.$refs;
      if (!newFormSepa) return;

      console.log(formSepaMethod, 'sepa');
      newFormSepa.show(formSepaMethod);

      if (newFormCard) newFormCard.close();
    },
    addCard(formCreditCard = {}) {
      const { newFormCard, newFormSepa } = this.$refs;
      if (!newFormCard) return;
      newFormCard.show(formCreditCard);

      if (newFormSepa) newFormSepa.close();
    },
    async saveCardMethod(creditCardForm) {
      if (creditCardForm.id) {
        this.editPatientCreditCard(creditCardForm);
      } else {
        this.createPatientCreditCard(creditCardForm);
      }
    },
    async createPatientCreditCard(dataForm) {
      const { newFormCard } = this.$refs;
      this.isLoading = true;
      try {
        await createCreditCard(dataForm);
        this.$showSnackbar('Cartão cadastrado com sucesso!');
        this.habilitaformCartao = false;
        if (this.isFirstCard) {
          this.$store.commit(`cards/${types.MUTATE_FIRST_CARD}`, false);
          this.$router.go(-1);
        }
        this.getPatientCards();
      } catch (error) {
        this.$showSnackbar(error.response.data[0]);
      } finally {
        this.isLoading = false;
        newFormCard.close();
      }
    },
    async saveSepadMethod(methodoSepaForm) {
      console.log(methodoSepaForm);
      if (methodoSepaForm.id) {
        console.log('this.editPatientCreditCard();');
        this.editPatientMethodSepa(methodoSepaForm);
      } else {
        console.log('this.createPatientCreditCard();');
        this.creatNewSepa(methodoSepaForm);
      }
    },
    async creatNewSepa(dataForm) {
      const { newFormSepa } = this.$refs;
      this.isLoading = true;
      try {
        await creatMethodSepa(dataForm);
        this.$showSnackbar('Débito Direto (SEPA) cadastrado com sucesso!');
        this.habilitaformCartao = false;
        this.creatNewSepa();
      } catch (error) {
        this.$showSnackbar(error.response.data[0]);
      } finally {
        this.isLoading = false;
        newFormSepa.close();
      }
    },

    async getPatientCards() {
      this.isLoading = true;
      const res = await getCreditCards();
      this.patientCards = res;
      this.isLoading = false;
    },
    async getPatientMethodoSepa() {
      this.isLoading = true;
      const res = await getMethodSepa();
      this.patientSepa = res.data;
      this.isLoading = false;
    },
    async editPatientCreditCard(prop) {
      const { newFormCard } = this.$refs;
      this.isLoading = true;
      const { status } = await updateCreditCard(prop);
      if (status === 200) {
        this.$showSnackbar('Cartão editado com sucesso!');
        newFormCard.close();
        this.getPatientCards();
      }
    },
    async editPatientMethodSepa(prop) {
      const { newFormSepa } = this.$refs;
      this.isLoading = true;
      const { status } = await updateMethodSepa(prop);
      if (status === 200) {
        this.$showSnackbar('Débito Direto (SEPA) editado com sucesso!');
        newFormSepa.close();
        this.getPatientMethodoSepa();
      }
    },
    async deletePatientCard(idCard) {
      this.isLoading = true;
      this.dialog = false;
      const status = await deleteCreditCard(idCard);
      if (status === 204) {
        this.getPatientCards();
        this.$showSnackbar('Cartão deletado com sucesso!');
        this.closeFormAndResetForm();
      }
    },
    async deletePatientMethodSepa(idCard) {
      this.isLoading = true;
      this.dialog = false;
      const status = await deleteMethodSepa(idCard);
      if (status === 204) {
        this.getPatientMethodoSepa();
        this.$showSnackbar('Débito Direto (SEPA) deletado com sucesso!');
        this.closeFormAndResetForm();
      }
    },
  },
};
</script>

<style scoped>
.v-card__title {
  line-height: 25px;
  word-break: break-word;
}
@media screen and (max-width: 420px) {
  .valor-cartao {
    font-size: 0.9rem !important;
  }
}
@media screen and (max-width: 320px) {
  .v-card__actions .v-btn.v-btn {
    width: 110px !important;
  }
}
</style>
